var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Template1"
  }, [_c('div', {
    staticClass: "card-header-tab"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button ', {
        active: _vm.currentTab === tab.key
      }],
      on: {
        "click": function($event) {
          _vm.setTab(tab.key)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab.value) + "\n      "), (tab.value == 'Client KYC') ? _c('span', {
      attrs: {
        "id": "first"
      }
    }, [_c('i', {
      staticClass: "fa fa-user"
    })]) : _vm._e(), _vm._v(" "), (tab.value == 'Other Information') ? _c('span', {
      attrs: {
        "id": "second"
      }
    }, [_c('i', {
      staticClass: "fa fa-info"
    })]) : _vm._e(), _vm._v(" "), (tab.value == 'Contracts') ? _c('span', {
      attrs: {
        "id": "third"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text-o"
    })]) : _vm._e(), _vm._v(" "), (tab.value == 'Approval Logs') ? _c('span', {
      attrs: {
        "id": "four"
      }
    }, [_c('i', {
      staticClass: "fa fa-thumbs-o-up"
    })]) : _vm._e()])
  })), _vm._v(" "), _c('div', [_c('keep-alive', [_c(_vm.currentTabComponent, {
    key: _vm.componentKey,
    ref: "Template1Ref",
    tag: "component",
    staticClass: "tab",
    attrs: {
      "viewRow": _vm.selectedEditRow,
      "shortname": _vm.cargoclientShortName,
      "selectclientSystemID": _vm.selectclientSystemID,
      "selectBusinessAccId": _vm.selectBusinessAccId,
      "statelist": _vm.statelist
    }
  })], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-045da61f","hasScoped":true}!./src/modules/clientmanagement/views/client/clientlisting/clienteview/clienteview.component.html
// module id = 706
// module chunks = 3